import React, { useState, ChangeEvent, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import FormField from '../ui/FormField';
import { login } from '../../store/authSlice';
import { RootState, AppDispatch } from '../../store/indexRedux';
import { useTranslation } from 'react-i18next';

interface FormData {
  email: string;
  password: string;
}

const LoginForm: React.FC = () => {
  const { t } = useTranslation('LoginForm');

  const [formData, setFormData] = useState<FormData>({ email: '', password: '' });
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state: RootState) => state.auth);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const { email, password } = formData;
    const result = await dispatch(login({ email, password }));

    if (login.fulfilled.match(result)) {
      if (result.payload.newPassRequired) {
        navigate('/new-password');
      } else {
        navigate('/');
      }
    }
  };

  return (
    <div className='pr-0 lg:pr-28'>
      <form onSubmit={handleSubmit}>
        <FormField
          type='text'
          name='email'
          placeholder={t('emailPlaceholder')}
          svgPath='M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z'
          value={formData.email}
          onChange={handleChange}
        />
        <FormField
          type='password'
          name='password'
          placeholder={t('passwordPlaceholder')}
          svgPath='M14 6a4 4 0 0 1-4.899 3.899l-1.955 1.955a.5.5 0 0 1-.353.146H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.293a.5.5 0 0 1 .146-.353l3.955-3.955A4 4 1 1 14 6Zm-4-2a.75.75 0 0 0 0 1.5.5.5 0 0 1 .5.5.75.75 0 0 0 1.5 0 2 2 0 0 0-2-2Z'
          value={formData.password}
          onChange={handleChange}
          className='my-5'
        />
        <button type='submit' className='btn btn-secondary mt-5 sm:btn-sm md:btn-md lg:btn-lg mb-10' disabled={loading}>
          {loading ? t('loggingIn') : t('loginButton')}
        </button>
      </form>
      {error && <div className='text-red-500'>{t('loginError')}</div>}
      <div>
        <NavLink to='/forgot-password'>{t('forgotPassword')}</NavLink>
      </div>
    </div>
  );
};

export default LoginForm;
